import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const SwitcherContainer = styled.div`
  position: relative;
  margin-left: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-left: 0;
    margin-top: ${theme.spacing.sm};
  }
`;

const LanguageButton = styled.button<{ isActive?: boolean }>`
  background: ${props => props.isActive ? theme.colors.primary : 'transparent'};
  color: ${props => props.isActive ? theme.colors.background : theme.colors.text};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  font-size: 0.9rem;
  cursor: pointer;
  margin-right: ${theme.spacing.xs};
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.isActive ? theme.colors.primary : theme.colors.primaryLight};
    color: ${props => props.isActive ? theme.colors.background : theme.colors.text};
  }
  
  &:last-child {
    margin-right: 0;
  }
`;

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    
    // Set the document direction based on language
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    
    // Add a class to the body for RTL specific styling if needed
    if (lng === 'ar') {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  };
  
  return (
    <SwitcherContainer>
      <LanguageButton 
        isActive={currentLanguage === 'en'} 
        onClick={() => changeLanguage('en')}
      >
        EN
      </LanguageButton>
      <LanguageButton 
        isActive={currentLanguage === 'ar'} 
        onClick={() => changeLanguage('ar')}
      >
        عربي
      </LanguageButton>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher; 